import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

type Props = {
  size: number
  pictureUrl?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Picture',
  props: {
    size: { default: 40 },
    pictureUrl: { default: undefined }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "picture",
    style: _normalizeStyle({
      backgroundImage: `url(${_ctx.pictureUrl})`,
      minWidth: `${_ctx.size}px`,
      minHeight: `${_ctx.size}px`,
    }),
    "data-testid": "picture"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4 /* STYLE */))
}
}

})